export const statusOptions = [
    {label: 'Отключен', value: false},
    {label: 'Включен', value: true}
];

export const statusStateOptions = [
    {label: 'Активен', value: false},
    {label: 'Не активен', value: true}
];
